import React, { ComponentType, useEffect } from 'react'
import { MyContext, MyContextProvider, useAppContext } from './ctx/MyContext'
import { QueryClient, QueryClientProvider } from 'react-query'
import Routing from './routing'
import { StylingProvider } from './ui/StylingProvider'
import { getSubappComp } from './_subapps/index'
import { useToast, ToastProvider } from '@lib/ui'


const queryClient = new QueryClient()

const RegisterUIControls = () => {
    const ctx = useAppContext()
    const t = useToast()

    useEffect(() => {
        // Navigate will be registered by the router itself
        ctx.ui.register.showToast(t.showToast)
    }, [])

    return null
}

export const App: ComponentType<{ ctx: MyContext }> = ({ ctx }) => {
    // TODO load only after we know we are authenticated
    // useEffect(() => {
    //
    //     ctx.app.store.loadSettings().then(r => {
    //         const fav = document.getElementById(
    //             'favicon',
    //         ) as HTMLLinkElement
    //         fav.href = r.favicon.href
    //         fav.type = r.favicon.type
    //
    //         console.log('Running version ' + r.appVersion)
    //     })
    // }, [])

    const AppComp = getAppComp(ctx)
    return (
        <QueryClientProvider client={queryClient}>
            <MyContextProvider value={{ ...ctx }}>
                <StylingProvider>
                    <ToastProvider>
                        <>
                            <RegisterUIControls />
                            <AppComp />
                        </>
                    </ToastProvider>
                </StylingProvider>
            </MyContextProvider>
        </QueryClientProvider>
    )
}


export const getAppComp = (ctx: MyContext): React.ComponentType => {

    let subappId = new URLSearchParams(window.location.search).get('subapp')
    if (!subappId) {
        subappId = ctx.app.store.settings.subapp || null
    }

    if (subappId) {
        const SubappCopm = getSubappComp(subappId)
        if (SubappCopm) {
            console.log('Subapp', subappId)
            return SubappCopm
        }
    }
    return Routing
}
